<template>
	<div id="wrapper" v-if="lszsz">
		<div id="page-wrapper" class="gray-bg px-0">
			<div class="row border-bottom white-bg mx-0 px-2">
				<nav class="navbar navbar-expand-lg navbar-light navbar-static-top">
					<div class="navbar-brand">
						<button @click="initializeBarcodeList()" :disabled="activePlace != null || activeCheckingPlace != null" class="btn-success btn btn-circle  btn-sm"><i class="fa fa-sync-alt"></i></button>
						<h4 class="d-inline-block font-italic font-weight-light" v-if="subTitle != null"> <i class="fa fa-angle-right mx-2"></i> {{subTitle}}</h4>
					</div>
					<button class="btn btn-sm btn-danger my-auto mr-1 ml-auto btn-circle fa-blink" v-if="this.battery_level <= 0.15"><i class="fas fa-battery-quarter "></i></button>	
					<button class="btn btn-sm btn-primary my-auto mr-1 ml-auto btn-circle" v-if="online === true"><i class="fa fa-wifi"></i></button>
					<button class="btn btn-sm btn-danger my-auto mr-1 ml-auto btn-circle" v-if="online === false"><i class="fa fa-wifi"></i><i class="fa fa-times"></i></button>
					<button class="navbar-toggler btn btn-primary text-white" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<i v-if="activePlace == null && activeCheckingPlace == null" class="fa fa-bars"></i>
						<i v-else class="fa fa-lock"></i>
					</button>
					<div class="collapse navbar-collapse" id="navbarNav" v-show="activePlace == null && activeCheckingPlace == null">
						<ul class="navbar-nav">
							<li class="nav-item" v-if="barcodeListExists == true" navbar-toggler
data-toggle="collapse" data-target="#navbarNav">
								<router-link class="nav-link" tag="a" to="/data-collection">Adatgyűjtés <span class="sr-only">(current)</span></router-link>
							</li>
							<li class="nav-item" v-if="barcodeListExists == true" navbar-toggler
data-toggle="collapse" data-target="#navbarNav">
								<router-link class="nav-link" tag="a" to="/checking">Ellenőrzés <span class="sr-only">(current)</span></router-link>
							</li>
							<li class="nav-item" navbar-toggler
data-toggle="collapse" data-target="#navbarNav">
								<router-link class="nav-link" tag="a" to="/upload_status">Feltöltés/Leadás<span class="sr-only">(current)</span></router-link>
							</li>
							<li class="nav-item" navbar-toggler data-toggle="collapse" data-target="#navbarNav" v-if="user && user.role == 2">
								<router-link class="nav-link" tag="a" to="/inventory-table">Leltárasztal<span class="sr-only">(current)</span></router-link>
							</li>
							<li class="nav-item" navbar-toggler data-toggle="collapse" data-target="#navbarNav" v-if="user && user.role == 2">
								<router-link class="nav-link" tag="a" to="/collected-items">Rögzített tételek<span class="sr-only">(current)</span></router-link>
							</li>
							<li class="nav-item" navbar-toggler data-toggle="collapse" data-target="#navbarNav" v-if="user && user.role == 2">
								<router-link class="nav-link" tag="a" to="/break">Szünet kezelés<span class="sr-only">(current)</span></router-link>
							</li>
							<li class="nav-item" navbar-toggler data-toggle="collapse" data-target="#navbarNav" v-if="user && user.role == 2">
								<router-link class="nav-link" tag="a" to="/devices">Eszköz kezelés<span class="sr-only">(current)</span></router-link>
							</li>
							<!--<li class="nav-item" navbar-toggler
data-toggle="collapse" data-target="#navbarNav">
								<router-link class="nav-link" tag="a" to="/break">Jelentkezés szünetre <span class="sr-only">(current)</span></router-link>
							</li>-->
							<li class="nav-item dropdown">
								<a v-if="user != null" class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									{{ user.name }}
								</a>
								<div class="dropdown-menu" aria-labelledby="navbarDropdown">
									<router-link tag="a" class="dropdown-item py-1" to="/profile" navbar-toggler
data-toggle="collapse" data-target="#navbarNav">
										<i class="fa fa-user"></i> Adataim
									</router-link>
									<a class="dropdown-item py-1" href="#" @click.prevent="logout()">
										<i class="fa fa-sign-out-alt"></i> Kijelentkezés
									</a>
								</div>
							</li>
						</ul>
					</div>
				</nav>
			</div>
				<router-view style="padding-bottom:0px;" />
			<Footer />
		</div>
		<div id="no_internet" style="position: fixed; display: none; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 6000; cursor: pointer;">
				<div class="widget red-bg p-lg text-center" style="position: absolute;  top: 50%;  left: 50%;  transform: translate(-50%,-50%);  -ms-transform: translate(-50%,-50%);">
					<div class="m-b-md">
							<i class="fa fa-wifi fa-4x"></i>
							<h1 class="m-xs"><i class="fa fa-times"></i></h1>
							<h3 class="font-bold no-margins">
									Hálózati hiba
							</h3>
							<small>Ellenőrizze internetkapcsolatát!</small>
					</div>
				</div>
		</div>
		<div v-if="downloading" class="overlay">
			<div class="overlay-container text-center">
				<i class="fa fa-spinner fa-3x fa-spin"></i>
				<h3 class="mb-3">Letöltés folyamatban</h3>
			</div>
		</div>
	</div>
</template>

<script>
import Footer from "./Footer";
import User from "../../apis/User";
import appService from '../../apis/appService.js'
import moment from 'moment'

export default {
	name: "app",
	components: {
		Footer
	},
	data(){
		return {
			connection: navigator.onLine,
			//online: true,
			battery_level: 1,
		}
	},
	computed:{
		barcodeListExists(){
			return this.$store.state.barcodeListExists;
		},
		subTitle(){
			return this.$store.state.subTitle;
		},
		activePlace(){
			return this.$store.state.activePlace;
		},
		activeCheckingPlace(){
			return this.$store.state.activeCheckingPlace;
		},
		lszsz(){
			return this.$store.state.lszsz;
		},
		last_barcode_list_refresh(){
			return this.$store.state.last_barcode_list_refresh;
		},
		device_id(){
			return this.$store.state.device_id;
		},
		user(){			
			return this.$store.state.user;
		},
		barcode_list_url(){
			return this.$store.state.barcode_list_url;
		},
		downloading(){
			return this.$store.state.downloading;
		},
		downloaded(){
			return this.$store.state.downloaded;
		},
		time(){
			return this.$store.state.time;
		},
		online(){
			return this.$store.state.online;
		},
	},
	methods: {
		updatePercentage(percentage){
			this.$store.commit('updateTime',percentage);
			if(percentage == 100){
				this.$store.commit('updateDownloaded',true);
				this.$store.commit('updateDownloading',false);
				this.$store.commit('updateBarcodeListExists',true);
				this.$store.commit('updateTime',0);
			}
			else if(percentage == 0){
				this.$store.commit('updateDownloaded',false);
				this.$store.commit('updateDownloading',false);
				this.$store.commit('updateBarcodeListExists',false);
			}
		},
		initializeBarcodeList(){
			this.$confirm({
				message: 'Biztos újra le szeretnéd tölteni a fájlokat?',
				button: {
					no: 'Nem',
					yes: 'Igen'
				},
				callback: confirm => {
					if (confirm) {
						this.$store.commit('updateDownloaded',false);
						this.$store.commit('updateDownloading',true);						
						
						appService.initializeBarcodeList(this.barcode_list_url);
						let currentdate = moment().format('YYYY-MM-DD HH:mm:ss');
						this.$store.commit('updateLastBarcodeListRefresh',currentdate);	
					}
				}
			});
		},
		updateOnlineStatus(e) {
			const { type } = e;
			this.connection = type === 'online';
		},
		logout() {
			clearInterval(window.onlineInterval);
			clearInterval(window.batteryInterval);
			User.logout().then(() => {
				this.$store.commit('updateLszsz',null);
				this.$store.commit('updateUser',null);
				localStorage.removeItem("auth");
				localStorage.removeItem("user");
				this.$router.push({
					name: "Login"
				});
			})
		},
		checkInternet(){
			if(this.connection){
				if(this.last_barcode_list_refresh != null){
					appService.getFinishedPlaces(this.last_barcode_list_refresh,this.user.project_id,this.lszsz,this.device_id).then( response => {
						this.$store.commit('updateOnline',true);
						
						if(response.data.length != 0){
							response.data.forEach(newitem => {
								appService.setPlaceStatus(newitem.lth_id,newitem.place_status_id);
							});
							let currentdate = moment().format('YYYY-MM-DD HH:mm:ss');
							this.$store.commit('updateLastBarcodeListRefresh',currentdate);
						}
					})
					.catch(() => {
						this.$store.commit('updateOnline',false);
					})
				}
			}else{
				this.$store.commit('updateOnline',false);
			}
		},
		checkBattery(){
			let vue = this;
			navigator.getBattery().then(function(battery) {
				vue.battery_level = battery.level;
			});
		}
		
  },
	watch: {
		connection(online) {
			if(online) {
				document.getElementById("no_internet").style.display = "none";
				appService.processUploadList();
			}else{
				document.getElementById("no_internet").style.display = "none"; //block
			}
		},
		lszsz(lszsz) {
			if(lszsz == null){
				this.logout();
			}
		}
	},
	mounted() {
    window.addEventListener('online',  this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  }, 
	beforeMount(){
	//Create interface between Webview and Native application
		window['tc26'] = {
			components:  this,
			updatePercentage: (percentage) =>  this.updatePercentage(percentage),
		};
	},
  beforeDestroy() {
    window.removeEventListener('online',  this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
		clearInterval(window.onlineInterval);
		clearInterval(window.batteryInterval);
  },
	created(){
		
		if(this.lszsz == null){
			this.logout();
		}
		User.auth(appService.getDeviceId())
		.then(response => {
			//kiszedtem innen,mert minek legyen itt, ha már betettük a loginnál
			//this.$store.commit('updateUser',response.data);
			//this.$root.$data.user = response.data;
			localStorage.setItem('user',JSON.stringify(response.data));
			this.$root.$data.barcodeListExists = false;
		});
		this.$root.$on('toggleCollapse', () => {
			this.collapsed = !this.collapsed;
		});
		this.checkInternet();
		window.onlineInterval = setInterval(() => {
			this.checkInternet();
		}, 8000); 
		this.checkBattery();
		window.batteryInterval = setInterval(() => {
			this.checkBattery();
		}, 10000); 
	}
};
</script>
<style>
.vsm--header{margin:1em 0; background-image:url('~@/assets/img/countit-logo.png'); height:3em; background-size:contain; background-repeat: no-repeat; background-position:50% 50%; filter:invert(0.5)}
</style>